import React, { useState, Fragment, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Tooltip from '@material-ui/core/Tooltip';
import { TooltipIcon } from '../../../../components/Icon';
import {
  getCategories,
  toggleCategory,
  initiateEditCategory,
  sortCategories,
  sortProducts,
  updateCategoriesRequestParams,
  updateSortedCategoriesList,
} from '../categoryActions';
import CategoryList from './components/CategoryList';
import { Icon, Button } from 'merchant-portal-components';
import BreadCrumb from '../../../../components/BreadCrumb/BreadCrumb';
import CategoriesSortModal from './CategorySort/CategoriesSortModal';
import { TextField, InputAdornment } from '@material-ui/core';
import _ from 'lodash';
import ReactGA from 'react-ga';
import PaginationControl from '../../../../components/Pagination/PaginationControl';
import { InfoIcon } from '../../InfoIcon';
const Wrapper = styled.div`
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  border-radius: 12px;
  padding: 37px 0;
`;

const SortDiv = styled.div`
  font-size: 17px;
  display: flex;
  visibility: ${(props) => (props.inactive ? 'hidden' : 'visible')};
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 15px 40px;
`;

const SortWrapper = styled.div`
  cursor: pointer;
  display: inline-block;
  font-weight: 600;
`;

const StyledTab = styled.div`
  display: flex;
  z-index: 5;
`;
const PaginationWrapper = styled.div`
  padding: 20px 45px;
  border-top: 1px solid lightgray;
`;
const StyledSpanCD = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  text-align: center;
  background-color: #2440ae;
  color: white;
  padding-left: ${(props) => (props.isSD == true ? '5px' : '3.2px')};
  padding-right: ${(props) => (props.isSD == true ? '5px' : '3.2px')};
  padding-top: ${(props) => (props.isSD == true ? '2px' : '3.2px')};
  padding-bottom: ${(props) => (props.isSD == true ? '2px' : '3.2px')};
  font-size: 13.5px;
`;

const StyledNmbrSpan = styled.span`
  display: block;
  margin-top: 15%;
`;

const StyledNmbrSpanInactive = styled.span`
  display: block;
  margin-top: 21%;
`;
const FilterButton = styled.div`
  display: inline-flex;
`;
const TxtContr = styled.div`
  margin-top: 6px;
  font-size: 18px;
  margin-right: 6px;
  color: #6f6f76;
`;

const StyledTabBtn = styled.button`
  z-index: 5;
  width: 160px;
  cursor: pointer;
  background-color: ${(props) =>
    props.isActive == false ? 'lightblue' : '#2440ae'};
  color: ${(props) => (props.isActive == false ? '#000' : '#fff')};
  background-color: ${(props) =>
    props.isActive == false ? '#fff' : '#E6EBFF'};
  color: ${(props) => (props.isActive == false ? '#DCDCDC' : '#2440ae')};
  font-weight: ${(props) => (props.isActive == false ? '' : '')};
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
`;

const TextSearch = styled.div``;
const TopDiv = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr;
  grid-gap: 20px;
  margin: 0 37px 37px 37px;
`;

const FilterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 40px;
`;
const FilterComponent = ({ selectedFilter, setSelectedFilter, categories }) => {
  return (
    <StyledTab>
      <StyledTabBtn
        isActive={selectedFilter == 'active'}
        onClick={() => {
          setSelectedFilter('active');
        }}
      >
        <FilterButton>
          <TxtContr>Active</TxtContr> &nbsp;{' '}
          <StyledSpanCD
            isSD={categories.filter((ech) => ech.is_active == true).length < 10}
          >
            <StyledNmbrSpan>
              {categories.filter((ech) => ech.is_active == true).length}
            </StyledNmbrSpan>
          </StyledSpanCD>
        </FilterButton>
      </StyledTabBtn>
      <StyledTabBtn
        isActive={selectedFilter == 'inactive'}
        onClick={() => {
          setSelectedFilter('inactive');
        }}
      >
        <FilterButton>
          <TxtContr>Inactive</TxtContr> &nbsp;{' '}
          <StyledSpanCD
            isSD={
              !(categories.filter((ech) => ech.is_active == false).length >= 10)
            }
          >
            <StyledNmbrSpanInactive>
              {categories.filter((ech) => ech.is_active == false).length}
            </StyledNmbrSpanInactive>
          </StyledSpanCD>
        </FilterButton>
      </StyledTabBtn>
      <InfoIcon />
    </StyledTab>
  );
};

const CategoryListContainer = ({
  categories,
  getCategories,
  toggleCategory,
  isRequestingGetCategories,
  handleCreateButtonClick,
  initiateEditCategory,
  sortCategories,
  sortProducts,
  isSortingRequested,
  requestParams,
  searchString,
  setSearchString,
  isSearching,
}) => {
  const [isSortModalOpen, setIsSortModalOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('active');
  const handleSearch = (e) => {
    const newSearchString = e.target.value.toLowerCase();
    setSearchString(newSearchString);
  };
  const handleClearSearch = () => {
    setSearchString('');
  };
  useEffect(() => {
    ReactGA.pageview(window.location.pathname, undefined, 'Category List');
  }, []);

  const categoryDisplayList = useMemo(() => {
    if (!categories) return [];
    switch (selectedFilter) {
      case 'active':
        return categories?.filter((each) => each.is_active == true);
      case 'inactive':
        return categories?.filter((each) => each.is_active == false);
      default:
        return categories;
    }
  }, [categories, selectedFilter]);

  return (
    <Fragment>
      <BreadCrumb />
      <Wrapper>
        <TopDiv>
          <TextSearch>
            <TextField
              type='text'
              style={{ width: '100%' }}
              variant='outlined'
              value={searchString}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <Icon className='fal fa-search' />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position='start'>
                    <Icon
                      className='fas fa-times-circle'
                      style={{ color: '#193053' }}
                      onClick={handleClearSearch}
                    />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
              placeholder='Search categories'
            />
          </TextSearch>
          <Button
            onClick={() => handleCreateButtonClick()}
            style={{ width: '100%' }}
          >
            Create a Category
          </Button>
        </TopDiv>
        <FilterWrapper>
          <FilterComponent
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            categories={categories}
          />
          <PaginationControl
            response={{
              ...categories,
              page: requestParams.page_number,
              page_size: requestParams.page_size,
              count: categories.length,
            }}
            requestParams={requestParams}
            updateAction={getCategories}
            type='categories'
          />
        </FilterWrapper>
        <SortDiv inactive={categoryDisplayList.length === 0}>
          <SortWrapper onClick={() => setIsSortModalOpen(true)}>
            <i
              style={{ color: '#2440AE' }}
              className='far fa-sort-amount-down'
            />
            <span style={{ color: '#2440AE' }}>Reorder Categories</span>
            <Tooltip
              style={{ marginRight: 'auto' }}
              title='Edit the position of categories to change the order that they are presented in to the user'
            >
              <span>
                <TooltipIcon style={{ color: '#2440AE' }} marginLeft />
              </span>
            </Tooltip>
          </SortWrapper>
        </SortDiv>

        <CategoryList
          isSearching={isSearching}
          categories={categoryDisplayList}
          toggleCategory={toggleCategory}
          initiateEditCategory={initiateEditCategory}
          requestParams={requestParams}
          setIsSortModalOpen={setIsSortModalOpen}
          getCategories={getCategories}
          isRequestingGetCategories={isRequestingGetCategories}
          selectedFilter={selectedFilter}
          searchString={searchString}
        />
        <PaginationWrapper>
          <PaginationControl
            response={{
              ...categories,
              page: requestParams.page_number,
              page_size: requestParams.page_size,
              count: categories.length,
            }}
            requestParams={requestParams}
            updateAction={getCategories}
            type='categories'
          />
        </PaginationWrapper>
        {isSortModalOpen && (
          <CategoriesSortModal
            categories={categories}
            setIsSortModalOpen={setIsSortModalOpen}
            sortCategories={sortCategories}
            sortProducts={sortProducts}
            isSortingRequested={isSortingRequested}
            formTypeName='categories'
            formHeadName='category'
          />
        )}
      </Wrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  categories: state.categoryReducer.allCategories,
  isRequestingGetCategories: state.categoryReducer.isRequestingGetCategories,
  isSortingRequested: state.categoryReducer.isSortingRequested,
  requestParams: state.categoryReducer.requestParams,
  allInitialCategories: state.categoryReducer.allInitialCategories,
});

export default connect(mapStateToProps, {
  getCategories,
  toggleCategory,
  initiateEditCategory,
  sortCategories,
  sortProducts,
  updateCategoriesRequestParams,
  updateSortedCategoriesList,
})(CategoryListContainer);
